import {
    PANELMANAGER_ACTIVATE_PANEL,
    PANELMANAGER_CLEAR_PANELPROPS,
    PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR,
    PANELMANAGER_CLOSE_PANEL,
    PANELMANAGER_CLOSE_PANEL_FINISH,
    PANELMANAGER_CLOSE_POPUP,
    PANELMANAGER_CLOSE_POPUP_FINISH,
    PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG,
    PANELMANAGER_HIDE_DELETESUCCESSDIALOG,
    PANELMANAGER_HIDE_PANELPROPSDIALOG,
    PANELMANAGER_MOVE_PANEL,
    PANELMANAGER_OPEN_PANEL,
    PANELMANAGER_OPEN_POPUP,
    PANELMANAGER_SET_PANEL_DIRTY,
    PANELMANAGER_SET_PANEL_ICON,
    PANELMANAGER_SET_PANEL_INVALID,
    PANELMANAGER_SET_PANEL_PATH,
    PANELMANAGER_SET_PANEL_TITLE,
    PANELMANAGER_SET_PANEL_TOOLTIP,
    PANELMANAGER_SET_PANELPROPS,
    PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR,
    PANELMANAGER_SET_SCROLLPOSITION,
    PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG,
    PANELMANAGER_SHOW_DELETESUCCESSDIALOG,
    PANELMANAGER_SHOW_PANELPROPSDIALOG
} from '../constants';

import {PanelConfig} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {
    getPanelIndex,
    getPopupIndex
} from '~/frontend/src/components/base/page/PageTabPanel/utilities';

// TODO: linter complains for wildcard but it's working... check how to solve this issue
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as panelTransformers from '~/frontend/src/transformers/panel';

// TODO: linter complains for wildcard but it's working... check how to solve this issue
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as moduleTransformers from '~/frontend/src/transformers/module';

import {
    OpenPanelAction,
    PanelPropsWithPanelType
} from '~/frontend/src/actions/panelManager/openPanel';
import {
    ClosePanelAction,
    ClosePanelFinishAction
} from '~/frontend/src/actions/panelManager/closePanel';
import {
    ClosePopupAction,
    ClosePopupFinishAction
} from '~/frontend/src/actions/panelManager/closePopup';
import {MovePanelAction} from '~/frontend/src/actions/panelManager/movePanel';
import {ActivatePanelAction} from '~/frontend/src/actions/panelManager/activatePanel';
import {ClearPanelPropsAction} from '~/frontend/src/actions/panelManager/clearPanelProps';
import {SetPanelPropsAction} from '~/frontend/src/actions/panelManager/setPanelProps';
import {SetPanelTitleAction} from '~/frontend/src/actions/panelManager/setPanelTitle';
import {SetPanelIconAction} from '~/frontend/src/actions/panelManager/setPanelIcon';
import {SetPanelTooltipAction} from '~/frontend/src/actions/panelManager/setPanelTooltip';
import {SetPanelDirtyAction} from '~/frontend/src/actions/panelManager/setPanelDirty';
import {SetPanelInvalidAction} from '~/frontend/src/actions/panelManager/setPanelInvalid';
import {SetPanelPathAction} from '~/frontend/src/actions/panelManager/setPanelPath';
import {ShowConfirmCloseDialogAction} from '~/frontend/src/actions/panelManager/showConfirmCloseDialog';
import {HideConfirmCloseDialogAction} from '~/frontend/src/actions/panelManager/hideConfirmCloseDialog';
import {ShowDeleteSuccessDialogAction} from '~/frontend/src/actions/panelManager/showDeleteSuccessDialog';
import {HideDeleteSuccessDialogAction} from '~/frontend/src/actions/panelManager/hideDeleteSuccessDialog';
import {ShowPanelPropsDialogAction} from '~/frontend/src/actions/panelManager/showPanelPropsDialog';
import {HidePanelPropsDialogAction} from '~/frontend/src/actions/panelManager/hidePanelPropsDialog';
import {SetPanelPropsValidationErrorAction} from '~/frontend/src/actions/panelManager/setPanelPropsValidationError';
import {ClearPanelPropsValidationErrorAction} from '~/frontend/src/actions/panelManager/clearPanelPropsValidationError';
import {SetScrollPositionAction} from '~/frontend/src/actions/panelManager/setScrollPosition';

type PanelPathMappings = {
    [ oldPath : string ] : string;
};

export type PanelManagerState = {
    activePanelKey? : string;
    activePanelKeyHistory : string[];
    openPanels : PanelConfig[];
    closedPanels : PanelConfig[];
    openPopups : PanelConfig[];
    panelPropsValidationError : ValidationError;
    panelPathMappings : PanelPathMappings;
    scrollPosition : number;
}

const relevantActions = [
    PANELMANAGER_ACTIVATE_PANEL,
    PANELMANAGER_CLEAR_PANELPROPS,
    PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR,
    PANELMANAGER_CLOSE_PANEL,
    PANELMANAGER_CLOSE_PANEL_FINISH,
    PANELMANAGER_CLOSE_POPUP,
    PANELMANAGER_CLOSE_POPUP_FINISH,
    PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG,
    PANELMANAGER_HIDE_DELETESUCCESSDIALOG,
    PANELMANAGER_HIDE_PANELPROPSDIALOG,
    PANELMANAGER_MOVE_PANEL,
    PANELMANAGER_OPEN_PANEL,
    PANELMANAGER_OPEN_POPUP,
    PANELMANAGER_SET_PANELPROPS,
    PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR,
    PANELMANAGER_SET_PANEL_DIRTY,
    PANELMANAGER_SET_PANEL_ICON,
    PANELMANAGER_SET_PANEL_INVALID,
    PANELMANAGER_SET_PANEL_PATH,
    PANELMANAGER_SET_PANEL_TITLE,
    PANELMANAGER_SET_PANEL_TOOLTIP,
    PANELMANAGER_SET_SCROLLPOSITION,
    PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG,
    PANELMANAGER_SHOW_DELETESUCCESSDIALOG,
    PANELMANAGER_SHOW_PANELPROPSDIALOG
];

type PanelManagerActions = OpenPanelAction | ClosePanelAction | ClosePanelFinishAction | ClosePopupAction | ClosePopupFinishAction | MovePanelAction | ActivatePanelAction | SetScrollPositionAction
    | ClearPanelPropsAction | SetPanelPropsAction | SetPanelTitleAction | SetPanelIconAction | SetPanelTooltipAction | SetPanelDirtyAction | SetPanelInvalidAction | SetPanelPathAction
    | ShowConfirmCloseDialogAction | HideConfirmCloseDialogAction
    | ShowDeleteSuccessDialogAction | HideDeleteSuccessDialogAction
    | ShowPanelPropsDialogAction | HidePanelPropsDialogAction | SetPanelPropsValidationErrorAction | ClearPanelPropsValidationErrorAction;

const debug = false;
const debugHistory : { state : any; unused : string; url : string }[] = [];

const windowHistoryPushState = ( panelKey : string, path : string ) => {
    const currentPanelKey = window.history.state?.panelKey,
          currentPath     = window.history.state?.path;

    if ( LP_URL ) {
        path = BASE_URL + document.location.pathname + path;
    }

    if ( debug ) {
        console.log( 'windowHistoryPushState'.asLogLine( 50 ) );
        console.log( '    panelKey', panelKey );
        console.log( '    path', path );
    }

    if ( panelKey !== currentPanelKey || path !== currentPath ) {
        if ( currentPath === '' ) {
            if ( debug ) {
                console.log( '    -> replace' );
            }

            window.history.replaceState( { panelKey, path }, 'REPLACE', path );

            if ( debug ) {
                if ( debugHistory.length ) {
                    debugHistory[ debugHistory.length - 1 ] = {
                        state : { panelKey, path },
                        unused: 'REPLACE_1',
                        url   : path
                    };
                }
                else {
                    debugHistory.push( {
                        state : { panelKey, path },
                        unused: 'REPLACE_1',
                        url   : path
                    } );
                }
            }
        }
        else {
            if ( debug ) {
                console.log( '    -> push' );
            }

            window.history.pushState( { panelKey, path }, 'PUSH', path );

            if ( debug ) {
                debugHistory.push( {
                    state : { panelKey, path },
                    unused: 'PUSH_1',
                    url   : path
                } );
            }
        }
    }
    else if ( debug ) {
        console.log( '    -> nothing changed' );
    }

    if ( debug ) {
        console.log( '    => debugHistory', JSON.parse( JSON.stringify( debugHistory ) ) );
        console.log( '       debugHistory.state === window.history.state', JSON.stringify( debugHistory[ debugHistory.length - 1 ]?.state ?? '' ) === JSON.stringify( window.history.state ?? '' ) );
        console.log( ''.asLogLine( 50 ) );
    }
};
const windowHistoryReplaceState = ( panelKey : string, path : string ) => {
    let historyPanelKey = window.history.state;

    if ( LP_URL ) {
        path = BASE_URL + document.location.pathname + path;
    }

    if ( historyPanelKey && typeof historyPanelKey === 'object' ) {
        historyPanelKey = Object.values( historyPanelKey ).reduce(
            ( stringPanelKey, char ) => {
                if ( typeof char === 'string' ) {
                    stringPanelKey += char;
                }
                return stringPanelKey;
            },
            ''
        );
    }

    if ( debug ) {
        console.log( 'windowHistoryReplaceState'.asLogLine( 50 ) );
        console.log( '    panelKey', panelKey );
        console.log( '    path', path );
        console.log( '    window.history.state', historyPanelKey );
    }

    if ( historyPanelKey === null || historyPanelKey === panelKey || document.location.hash === path || document.location.hash === '' ) {
        if ( debug ) {
            console.log( '    -> replace' );
        }

        window.history.replaceState( { panelKey, path }, 'REPLACE', path );

        if ( debug ) {
            if ( debugHistory.length ) {
                debugHistory[ debugHistory.length - 1 ] = {
                    state : { panelKey, path },
                    unused: 'REPLACE_2',
                    url   : path
                };
            }
            else {
                debugHistory.push( {
                    state : { panelKey, path },
                    unused: 'REPLACE_2',
                    url   : path
                } );
            }
        }
    }
    else {
        if ( debug ) {
            console.log( '    -> push' );
        }

        window.history.pushState( { panelKey, path }, 'PUSH', path );

        if ( debug ) {
            debugHistory.push( {
                state : { panelKey, path },
                unused: 'PUSH_2',
                url   : path
            } );
        }
    }

    if ( debug ) {
        console.log( '    => debugHistory', JSON.parse( JSON.stringify( debugHistory ) ) );
        console.log( ''.asLogLine( 50 ) );
    }
};

const initialState : PanelManagerState = {
    activePanelKeyHistory    : [],
    openPanels               : [],
    closedPanels             : [],
    openPopups               : [],
    panelPropsValidationError: {} as ValidationError,
    panelPathMappings        : {},
    scrollPosition           : 0
};

/**
 * PanelManager reducer
 *
 * @param state
 * @param action
 */
export default function panelManagerReducer( state : PanelManagerState = initialState, action : PanelManagerActions ) : PanelManagerState {
    let retVal = state;

    if ( relevantActions.includes( action.type ) ) {
        const changedState = { ...state };

        let changed = false,
            panelIndexOrKey : number | string,
            panelKey : string,
            panelProps : PanelProps,
            propsToSet : PanelProps | undefined,
            panelIndex : number | undefined,
            popupIndex : number | undefined,
            oldPanelIndex : number | undefined,
            panelCounter : number,
            scrollPosition : number;

        switch ( action.type ) {
            /**
             * PANELMANAGER_OPEN_PANEL
             * Open a new panel by adding the appropriate panel config to the openPanels array.
             * Panel key will be generated out of panel type and a counter to enable multiple panels from same type.
             * For now, only explicit named panelTypes can be opened.
             * TODO: implement logic to decide what panelType has to be opened for the current CI-Item and User etc.
             */
            case PANELMANAGER_OPEN_PANEL:
                ( { panelProps } = action );

                if ( panelProps ) {
                    changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );

                    // create unique panelKey
                    // by rootItemId (for existing)
                    if ( panelProps.rootItemId > 0 ) {
                        panelKey = `${panelProps.panelType}-${panelProps.viewKey ? `${panelProps.viewKey.replace( /(\.|:| |\(|\))/g, '_' )}-` : ''}${panelProps.rootItemId}`;
                    }
                    // by counting up (for new)
                    else if ( panelProps.rootItemId !== undefined ) {
                        panelCounter = 1;

                        do {
                            panelKey = `${panelProps.panelType}-new-${panelCounter++}`;
                        } while ( changedState.openPanels.find( panel => panel.panelProps.panelKey === panelKey ) )
                    }
                    // by rootItemType and rootItemKey
                    else if ( panelProps.rootItemType && panelProps.rootItemKey ) {
                        panelKey = `${panelProps.panelType}-${panelProps.viewKey ? `${panelProps.viewKey.replace( /(\.|:| |\(|\))/g, '_' )}-` : ''}${panelProps.rootItemType}-${panelProps.rootItemKey.replaceAll( /[.:@]/g, '-' )}`;
                    }
                    // by counting up
                    else {
                        panelCounter = 1;

                        do {
                            panelKey = `${panelProps.panelType}-${panelProps.viewKey ? `${panelProps.viewKey.replace( /(\.|:| |\(|\))/g, '_' )}-` : ''}${panelCounter++}`;
                        } while ( changedState.openPanels.find( panel => panel.panelProps.panelKey === panelKey ) )
                    }
                    panelProps.panelKey = panelKey;

                    const panelConfig = changedState.openPanels.find( panel => panel.panelProps.panelKey === panelKey );

                    // no panel for key exists -> add as new
                    if ( !panelConfig ) {
                        if ( action.processFinalPanelProps ) {
                            panelProps = action.processFinalPanelProps( panelProps as PanelPropsWithPanelType );
                        }

                        if ( action.panelIndex !== undefined ) {
                            changedState.openPanels.splice(
                                action.panelIndex,
                                0,
                                {
                                    panelProps,
                                    showConfirmCloseDialog : false,
                                    showDeleteSuccessDialog: false,
                                    showPanelPropsDialog   : false,
                                    path                   : action.path ?? ''
                                }
                            );
                        }
                        else {
                            changedState.openPanels.push(
                                {
                                    panelProps,
                                    showConfirmCloseDialog : false,
                                    showDeleteSuccessDialog: false,
                                    showPanelPropsDialog   : false,
                                    path                   : action.path ?? ''
                                }
                            );
                        }
                    }

                    if ( !action.inBackground ) {

                        // add current active panel to panel history
                        if ( changedState.activePanelKey ) {
                            changedState.activePanelKeyHistory = ( [] as string[] ).concat( changedState.activePanelKeyHistory );

                            changedState.activePanelKeyHistory.unshift( changedState.activePanelKey );

                            if ( changedState.activePanelKeyHistory.length > 25 ) {
                                changedState.activePanelKeyHistory = changedState.activePanelKeyHistory.slice( 0, 24 );
                            }
                        }

                        changedState.activePanelKey = panelKey;
                    }

                    // remove panel from closed panels (if)
                    changedState.closedPanels = changedState.closedPanels.reduce(
                        ( reducedClosedPanels, panelConfigToCheck ) => {
                            if ( panelConfigToCheck.panelProps.panelTabTitle !== panelProps.panelTabTitle ) {
                                reducedClosedPanels.push( panelConfigToCheck );
                            }
                            return reducedClosedPanels;
                        },
                        [] as PanelConfig[]
                    );

                    changed = true;
                }
                break;

            /**
             * PANELMANAGER_OPEN_POPUP
             * Open a new popup by adding the appropriate panel config to the openPopups array.
             * Panel key will be generated out of panel type and a counter to enable multiple panels from same type.
             */
            case PANELMANAGER_OPEN_POPUP:
                ( { panelProps } = action );

                if ( panelProps ) {
                    changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );

                    // create unique panelKey
                    // by rootItemId (for existing)
                    if ( panelProps.rootItemId > 0 ) {
                        panelKey = `popup-${panelProps.panelType}-${panelProps.viewKey ? `${panelProps.viewKey.replace( /(\.|:| |\(|\))/g, '_' )}-` : ''}${panelProps.rootItemId}`;
                    }
                    // by counting up (for new)
                    else if ( panelProps.rootItemId !== undefined ) {
                        panelCounter = 1;

                        do {
                            panelKey = `popup-${panelProps.panelType}-new-${panelCounter++}`;
                        } while ( changedState.openPopups.find( panel => panel.panelProps.panelKey === panelKey ) )
                    }
                    // by rootItemType and rootItemKey
                    else if ( panelProps.rootItemType && panelProps.rootItemKey ) {
                        panelKey = `popup-${panelProps.panelType}-${panelProps.viewKey ? `${panelProps.viewKey.replace( /(\.|:| |\(|\))/g, '_' )}-` : ''}${panelProps.rootItemType}-${panelProps.rootItemKey.replaceAll( /[.:@]/g, '-' )}`;
                    }
                    // by counting up
                    else {
                        panelCounter = 1;

                        do {
                            panelKey = `popup-${panelProps.panelType}-${panelProps.viewKey ? `${panelProps.viewKey.replace( /(\.|:| |\(|\))/g, '_' )}-` : ''}${panelCounter++}`;
                        } while ( changedState.openPopups.find( panel => panel.panelProps.panelKey === panelKey ) )
                    }
                    panelProps.panelKey = panelKey;

                    const panelConfig = changedState.openPopups.find( panel => panel.panelProps.panelKey === panelKey );

                    // no panel for key exists -> add as new
                    if ( !panelConfig ) {
                        if ( action.processFinalPanelProps ) {
                            panelProps = action.processFinalPanelProps( panelProps as PanelPropsWithPanelType );
                        }

                        changedState.openPopups.push( {
                            panelProps,
                            showConfirmCloseDialog : false,
                            showDeleteSuccessDialog: false,
                            showPanelPropsDialog   : false,
                            path                   : action.path ?? '',
                            isBlocking             : action.isBlocking
                        } );
                    }

                    changed = true;
                }
                break;

            case PANELMANAGER_CLOSE_PANEL:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );

                        const closedPanel = changedState.openPanels.splice( panelIndex, 1 )[ 0 ];
                        if ( closedPanel ) {

                            // hydrate panel props
                            closedPanel.panelProps = {
                                ...closedPanel.panelProps
                            };

                            if ( closedPanel.panelProps.moduleTransformer ) {
                                const moduleTransformer = moduleTransformers[ closedPanel.panelProps.moduleTransformer ];

                                if ( moduleTransformer?.hydrate ) {
                                    closedPanel.panelProps = moduleTransformer.hydrate( closedPanel.panelProps );
                                }
                                else if ( moduleTransformer ) {
                                    closedPanel.panelProps = moduleTransformer( closedPanel.panelProps );
                                }
                            }

                            if ( closedPanel.panelProps.panelTransformer ) {
                                const panelTransformer = panelTransformers[ closedPanel.panelProps.panelTransformer ];

                                if ( panelTransformer?.hydrate ) {
                                    closedPanel.panelProps = panelTransformer.hydrate( closedPanel.panelProps );
                                }
                                else if ( panelTransformer ) {
                                    closedPanel.panelProps = panelTransformer( closedPanel.panelProps );
                                }
                            }

                            // hydrate subPanel props
                            if ( closedPanel.panelProps.subPanelProps ) {
                                closedPanel.panelProps.subPanelProps = {
                                    ...closedPanel.panelProps.subPanelProps
                                };

                                const subPanelKeys = Object.keys( closedPanel.panelProps.subPanelProps ?? {} );
                                for ( const subPanelKey of subPanelKeys ) {
                                    closedPanel.panelProps.subPanelProps[ subPanelKey ] = {
                                        ...closedPanel.panelProps.subPanelProps[ subPanelKey ]
                                    };

                                    if ( closedPanel.panelProps.subPanelProps[ subPanelKey ].moduleTransformer ) {
                                        const subModuleTransformer = moduleTransformers[ closedPanel.panelProps.subPanelProps[ subPanelKey ].moduleTransformer ];

                                        if ( subModuleTransformer?.hydrate ) {
                                            closedPanel.panelProps.subPanelProps[ subPanelKey ] = subModuleTransformer.hydrate( closedPanel.panelProps.subPanelProps[ subPanelKey ] );
                                        }
                                        else if ( subModuleTransformer ) {
                                            closedPanel.panelProps.subPanelProps[ subPanelKey ] = subModuleTransformer( closedPanel.panelProps.subPanelProps[ subPanelKey ] );
                                        }
                                    }

                                    if ( closedPanel.panelProps.subPanelProps[ subPanelKey ].panelTransformer ) {
                                        const subPanelTransformer = panelTransformers[ closedPanel.panelProps.subPanelProps[ subPanelKey ].panelTransformer ];

                                        if ( subPanelTransformer?.hydrate ) {
                                            closedPanel.panelProps.subPanelProps[ subPanelKey ] = subPanelTransformer.hydrate( closedPanel.panelProps.subPanelProps[ subPanelKey ] );
                                        }
                                        else if ( subPanelTransformer ) {
                                            closedPanel.panelProps.subPanelProps[ subPanelKey ] = subPanelTransformer( closedPanel.panelProps.subPanelProps[ subPanelKey ] );
                                        }
                                    }
                                }
                            }

                            // remove closed panel from closed panels (if)
                            changedState.closedPanels = changedState.closedPanels.reduce(
                                ( reducedClosedPanels, panelConfig ) => {
                                    if ( panelConfig.panelProps.panelTabTitle !== closedPanel.panelProps.panelTabTitle ) {
                                        reducedClosedPanels.push( panelConfig );
                                    }
                                    return reducedClosedPanels;
                                },
                                [] as PanelConfig[]
                            );
                            // add closed panel to closed panels at top
                            changedState.closedPanels.unshift( closedPanel );
                            // limit closedPanels to 20 entries
                            if ( changedState.closedPanels.length > 20 ) {
                                changedState.closedPanels.splice( 20 - 1 );
                            }
                        }

                        // remove panelKey from history
                        if ( changedState.activePanelKeyHistory?.length ) {
                            for ( let i = changedState.activePanelKeyHistory.length - 1; i >= 0; i-- ) {
                                if ( changedState.activePanelKeyHistory[ i ] === panelKey ) {
                                    changedState.activePanelKeyHistory.splice( i, 1 );
                                }
                            }
                            changedState.activePanelKeyHistory = ( [] as string[] ).concat( changedState.activePanelKeyHistory );
                        }

                        // remove from panel path mappings
                        if ( !changedState.openPanels.length ) {
                            changedState.panelPathMappings = {};
                        }
                        else {
                            changedState.panelPathMappings = Object.keys( changedState.panelPathMappings ?? {} ).reduce(
                                ( newPanelPathMappings, newPanelKey ) => {
                                    if ( changedState.panelPathMappings[ newPanelKey ] !== closedPanel.path ) {
                                        newPanelPathMappings[ newPanelKey ] = changedState.panelPathMappings[ newPanelKey ];
                                    }

                                    return newPanelPathMappings;
                                },
                                {} as PanelPathMappings
                            );
                        }

                        // if closed panel was active
                        if ( panelKey === changedState.activePanelKey ) {

                            // activate first panel of history
                            if ( changedState.activePanelKeyHistory?.length ) {
                                changedState.activePanelKey = changedState.activePanelKeyHistory.shift();
                                changedState.activePanelKeyHistory = ( [] as string[] ).concat( changedState.activePanelKeyHistory );
                            }
                            // activate tab to the right of the closed panel (if there was one)
                            else if ( changedState.openPanels[ panelIndex ] ) {
                                changedState.activePanelKey = changedState.openPanels[ panelIndex ].panelProps.panelKey;
                            }
                            // activate the last tab
                            else if ( changedState.openPanels[ changedState.openPanels.length - 1 ] ) {
                                changedState.activePanelKey = changedState.openPanels[ changedState.openPanels.length - 1 ].panelProps.panelKey;
                            }
                            // activate first panel otherwise
                            else if ( changedState.openPanels.length ) {
                                changedState.activePanelKey = changedState.openPanels[ 0 ].panelProps.panelKey;
                            }
                            else {
                                delete changedState.activePanelKey;
                                windowHistoryPushState( 'noPanel', '#' );
                            }

                            // active panel -> set browser history
                            if ( changedState.activePanelKey ) {
                                const activePanelIndex = getPanelIndex( changedState.activePanelKey, changedState.openPanels );

                                if ( activePanelIndex !== undefined ) {
                                    windowHistoryPushState( changedState.openPanels[ activePanelIndex ].panelProps.panelKey, changedState.openPanels[ activePanelIndex ].path );
                                }
                            }
                        }

                        changed = true;
                    }
                }
                break;

            case PANELMANAGER_CLOSE_PANEL_FINISH:
                changed = true;
                break;

            case PANELMANAGER_CLOSE_POPUP:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPopupIndex( panelKey, changedState.openPopups );

                    if ( panelIndex !== undefined ) {
                        changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );

                        changedState.openPopups.splice( panelIndex, 1 );

                        changed = true;
                    }
                }
                break;

            case PANELMANAGER_CLOSE_POPUP_FINISH:
                changed = true;
                break;

            case PANELMANAGER_MOVE_PANEL:
                ( { oldPanelIndex, panelIndex } = action );

                if (
                    panelIndex !== undefined
                    && oldPanelIndex !== undefined
                ) {
                    changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );

                    changedState.openPanels.splice( panelIndex, 0, changedState.openPanels.splice( oldPanelIndex, 1 )[ 0 ] );

                    changed = true;
                }
                break;

            case PANELMANAGER_ACTIVATE_PANEL:
                ( { panelIndexOrKey, propsToSet } = action );

                if ( typeof panelIndexOrKey === 'string' ) {
                    panelKey = panelIndexOrKey;
                    panelIndex = getPanelIndex( panelIndexOrKey, changedState.openPanels );
                }
                else {
                    panelKey = changedState.openPanels[ panelIndexOrKey ]?.panelProps.panelKey;
                    panelIndex = panelIndexOrKey;
                }

                if (
                    panelIndex !== undefined
                    && changedState.activePanelKey !== panelKey
                ) {
                    // add current active panel to history
                    if ( changedState.activePanelKey ) {
                        changedState.activePanelKeyHistory.unshift( changedState.activePanelKey );

                        if ( changedState.activePanelKeyHistory.length > 25 ) {
                            changedState.activePanelKeyHistory = changedState.activePanelKeyHistory.slice( 0, 24 );
                        }

                        changedState.activePanelKeyHistory = ( [] as string[] ).concat( changedState.activePanelKeyHistory );
                    }

                    changedState.activePanelKey = panelKey;

                    // set browser history
                    if ( !action.historyNavigation ) {
                        windowHistoryPushState( panelKey, changedState.openPanels[ panelIndex ].path );
                    }
                    else {
                        windowHistoryReplaceState( panelKey, changedState.panelPathMappings[ changedState.openPanels[ panelIndex ].path ] ?? changedState.openPanels[ panelIndex ].path );
                    }

                    changed = true;
                }

                // set props
                if (
                    panelIndex !== undefined
                    && changedState.activePanelKey === panelKey
                    && propsToSet
                ) {
                    delete propsToSet.schema;
                    delete propsToSet.status;
                    delete propsToSet.viewKey;
                    delete propsToSet.rootItemId;
                    delete propsToSet.rootItemKey;
                    delete propsToSet.rootItemType;

                    changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                    changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );
                    changedState.openPanels[ panelIndex ].panelProps = Object.assign( {}, changedState.openPanels[ panelIndex ].panelProps );

                    changedState.openPanels[ panelIndex ].panelProps = {
                        ...changedState.openPanels[ panelIndex ].panelProps,
                        ...propsToSet
                    };

                    changed = true;
                }

                break;

            case PANELMANAGER_SET_PANEL_TITLE:
                ( { panelKey } = action );

                if ( panelKey ) {
                    if ( !panelKey.match( /^popup-/ ) ) {
                        panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                        if (
                            panelIndex !== undefined
                            && changedState.openPanels[ panelIndex ].panelProps.panelTabTitle !== action.title
                        ) {
                            changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                            changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );
                            changedState.openPanels[ panelIndex ].panelProps = Object.assign( {}, changedState.openPanels[ panelIndex ].panelProps );

                            changedState.openPanels[ panelIndex ].panelProps.panelTabTitle = action.title;

                            // remove panel from closed panels (if)
                            changedState.closedPanels = changedState.closedPanels.reduce(
                                ( reducedClosedPanels, panelConfigToCheck ) => {
                                    if ( panelConfigToCheck.panelProps.panelTabTitle !== action.title ) {
                                        reducedClosedPanels.push( panelConfigToCheck );
                                    }
                                    return reducedClosedPanels;
                                },
                                [] as PanelConfig[]
                            );

                            changed = true;
                        }
                    }
                    else {
                        popupIndex = getPopupIndex( panelKey, changedState.openPopups );

                        if (
                            popupIndex !== undefined
                            && changedState.openPopups[ popupIndex ].panelProps.panelTabTitle !== action.title
                        ) {
                            changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                            changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );
                            changedState.openPopups[ popupIndex ].panelProps = Object.assign( {}, changedState.openPopups[ popupIndex ].panelProps );

                            changedState.openPopups[ popupIndex ].panelProps.panelTabTitle = action.title;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_SET_PANEL_ICON:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if (
                        panelIndex !== undefined
                        && changedState.openPanels[ panelIndex ].panelProps.panelTabIcon !== action.icon
                    ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );
                        changedState.openPanels[ panelIndex ].panelProps = Object.assign( {}, changedState.openPanels[ panelIndex ].panelProps );

                        changedState.openPanels[ panelIndex ].panelProps.panelTabIcon = action.icon;

                        changed = true;
                    }
                }
                break;

            case PANELMANAGER_SET_PANEL_TOOLTIP:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if (
                        panelIndex !== undefined
                        && changedState.openPanels[ panelIndex ].panelProps.panelTooltip !== action.tooltip
                    ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );
                        changedState.openPanels[ panelIndex ].panelProps = Object.assign( {}, changedState.openPanels[ panelIndex ].panelProps );

                        changedState.openPanels[ panelIndex ].panelProps.panelTooltip = action.tooltip;

                        changed = true;
                    }
                }
                break;

            case PANELMANAGER_SET_PANEL_DIRTY:
                ( { panelKey } = action );

                if ( panelKey ) {
                    if ( !panelKey.match( /^popup-/ ) ) {
                        panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                        if (
                            panelIndex !== undefined
                            && changedState.openPanels[ panelIndex ].isDirty !== action.dirty
                        ) {
                            changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                            changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                            changedState.openPanels[ panelIndex ].isDirty = action.dirty;

                            changed = true;
                        }
                    }
                    else {
                        popupIndex = getPopupIndex( panelKey, changedState.openPopups );

                        if (
                            popupIndex !== undefined
                            && changedState.openPopups[ popupIndex ].isDirty !== action.dirty
                        ) {
                            changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                            changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );

                            changedState.openPopups[ popupIndex ].isDirty = action.dirty;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_SET_PANEL_INVALID:
                ( { panelKey } = action );

                if ( panelKey ) {
                    if ( !panelKey.match( /^popup-/ ) ) {
                        panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                        if (
                            panelIndex !== undefined
                            && changedState.openPanels[ panelIndex ].isInvalid !== action.invalid
                        ) {
                            changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                            changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                            changedState.openPanels[ panelIndex ].isInvalid = action.invalid;

                            changed = true;
                        }
                    }
                    else {
                        popupIndex = getPopupIndex( panelKey, changedState.openPopups );

                        if (
                            popupIndex !== undefined
                            && changedState.openPopups[ popupIndex ].isInvalid !== action.invalid
                        ) {
                            changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                            changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );

                            changedState.openPopups[ popupIndex ].isInvalid = action.invalid;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_SET_PANEL_PATH:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        if ( changedState.openPanels[ panelIndex ].path !== action.path ) {
                            changedState.panelPathMappings = { ...changedState.panelPathMappings };
                            changedState.panelPathMappings[ changedState.openPanels[ panelIndex ].path ] = action.path;
                            for ( const oldPath of Object.keys( changedState.panelPathMappings ?? {} ) ) {
                                if ( changedState.panelPathMappings[ oldPath ] === changedState.openPanels[ panelIndex ].path ) {
                                    changedState.panelPathMappings[ oldPath ] = action.path;
                                }
                            }

                            changedState.openPanels = [ ...changedState.openPanels ];
                            changedState.openPanels[ panelIndex ] = { ...changedState.openPanels[ panelIndex ] };

                            changedState.openPanels[ panelIndex ].path = action.path;

                            changed = true;
                        }

                        // active -> update browser history
                        if ( panelKey === changedState.activePanelKey ) {
                            //windowHistoryReplaceState( panelKey, action.path );
                            windowHistoryPushState( panelKey, action.path );
                        }
                    }
                }
                break;

            case PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                        if ( !changedState.openPanels[ panelIndex ].showConfirmCloseDialog ) {
                            changedState.openPanels[ panelIndex ].showConfirmCloseDialog = true;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                        if ( changedState.openPanels[ panelIndex ].showConfirmCloseDialog ) {
                            changedState.openPanels[ panelIndex ].showConfirmCloseDialog = false;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_SHOW_DELETESUCCESSDIALOG:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                        if ( !changedState.openPanels[ panelIndex ].showDeleteSuccessDialog ) {
                            changedState.openPanels[ panelIndex ].showDeleteSuccessDialog = true;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_HIDE_DELETESUCCESSDIALOG:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                        if ( changedState.openPanels[ panelIndex ].showDeleteSuccessDialog ) {
                            changedState.openPanels[ panelIndex ].showDeleteSuccessDialog = false;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_SHOW_PANELPROPSDIALOG:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                        if ( !changedState.openPanels[ panelIndex ].showPanelPropsDialog ) {
                            changedState.openPanels[ panelIndex ].showPanelPropsDialog = true;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_HIDE_PANELPROPSDIALOG:
                ( { panelKey } = action );

                if ( panelKey ) {
                    panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                    if ( panelIndex !== undefined ) {
                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                        if ( changedState.openPanels[ panelIndex ].showPanelPropsDialog ) {
                            changedState.openPanels[ panelIndex ].showPanelPropsDialog = false;

                            changed = true;
                        }
                    }
                }
                break;

            case PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR:
                changedState.panelPropsValidationError = action.panelPropsValidationError;

                changed = true;
                break;

            case PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR:
                changedState.panelPropsValidationError = {} as ValidationError;

                changed = true;
                break;

            case PANELMANAGER_CLEAR_PANELPROPS:
                ( { panelKey } = action );

                if ( panelKey ) {
                    if ( !panelKey.match( /^popup-/ ) ) {
                        panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                        // panel
                        if ( panelIndex !== undefined ) {
                            changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                            changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                            changedState.openPanels[ panelIndex ].panelProps = {};

                            changed = true;
                        }

                        // subPanel(s)
                        else {
                            for ( const openPanel of changedState.openPanels ) {
                                const openPanelKey = openPanel.panelProps.panelKey,
                                      matches      = action.panelKey.match( `^${openPanelKey}_(.*)$` ),
                                      subPanelKey  = matches?.length === 2 ? matches[ 1 ] : undefined;

                                if ( subPanelKey ) {
                                    panelIndex = getPanelIndex( openPanelKey, changedState.openPanels );

                                    if ( panelIndex !== undefined ) {
                                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );
                                        changedState.openPanels[ panelIndex ].panelProps = Object.assign( {}, changedState.openPanels[ panelIndex ].panelProps );

                                        const subPanelPath = subPanelKey.split( '_' );
                                        let parentProps = changedState.openPanels[ panelIndex ].panelProps;

                                        for ( let i = 0; i < subPanelPath.length; i++ ) {
                                            if ( parentProps.subPanelProps === undefined ) {
                                                parentProps.subPanelProps = {};
                                            }
                                            else {
                                                parentProps.subPanelProps = Object.assign( {}, parentProps.subPanelProps );
                                            }

                                            // end up
                                            if ( i === subPanelPath.length - 1 ) {
                                                delete parentProps.subPanelProps[ subPanelPath[ i ] ];

                                                if ( !Object.keys( parentProps.subPanelProps ?? {} ) ) {
                                                    delete parentProps.subPanelProps;
                                                }

                                                changed = true;
                                            }

                                            // step deeper
                                            else {
                                                if ( parentProps.subPanelProps[ subPanelPath[ i ] ] === undefined ) {
                                                    parentProps.subPanelProps[ subPanelPath[ i ] ] = {};
                                                }
                                                parentProps = parentProps.subPanelProps[ subPanelPath[ i ] ];
                                            }
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        popupIndex = getPopupIndex( panelKey, changedState.openPopups );

                        // popup
                        if ( popupIndex !== undefined ) {
                            changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                            changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );

                            changedState.openPopups[ popupIndex ].panelProps = {};

                            changed = true;
                        }

                        // subPanel(s)
                        else {
                            for ( const openPopup of changedState.openPopups ) {
                                const openPanelKey = openPopup.panelProps.panelKey,
                                      matches      = action.panelKey.match( `^${openPanelKey}_(.*)$` ),
                                      subPanelKey  = matches?.length === 2 ? matches[ 1 ] : undefined;

                                if ( subPanelKey ) {
                                    popupIndex = getPopupIndex( openPanelKey, changedState.openPopups );

                                    if ( popupIndex !== undefined ) {
                                        changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                                        changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );
                                        changedState.openPopups[ popupIndex ].panelProps = Object.assign( {}, changedState.openPopups[ popupIndex ].panelProps );

                                        const subPanelPath = subPanelKey.split( '_' );
                                        let parentProps = changedState.openPopups[ popupIndex ].panelProps;

                                        for ( let i = 0; i < subPanelPath.length; i++ ) {
                                            if ( parentProps.subPanelProps === undefined ) {
                                                parentProps.subPanelProps = {};
                                            }
                                            else {
                                                parentProps.subPanelProps = Object.assign( {}, parentProps.subPanelProps );
                                            }

                                            // end up
                                            if ( i === subPanelPath.length - 1 ) {
                                                delete parentProps.subPanelProps[ subPanelPath[ i ] ];

                                                if ( !Object.keys( parentProps.subPanelProps ?? {} ) ) {
                                                    delete parentProps.subPanelProps;
                                                }

                                                changed = true;
                                            }

                                            // step deeper
                                            else {
                                                if ( parentProps.subPanelProps[ subPanelPath[ i ] ] === undefined ) {
                                                    parentProps.subPanelProps[ subPanelPath[ i ] ] = {};
                                                }
                                                parentProps = parentProps.subPanelProps[ subPanelPath[ i ] ];
                                            }
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
                break;

            case PANELMANAGER_SET_PANELPROPS:
                ( { panelKey, panelProps } = action );

                if ( panelKey && panelProps ) {
                    if ( !panelKey.match( /^popup-/ ) ) {
                        panelIndex = getPanelIndex( panelKey, changedState.openPanels );

                        // panel
                        if ( panelIndex !== undefined ) {
                            if ( !panelProps.panelKey ) {
                                panelProps.panelKey = panelKey;
                            }
                            changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                            changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );

                            changedState.openPanels[ panelIndex ].panelProps = panelProps;

                            changed = true;
                        }

                        // subPanel(s)
                        else {
                            for ( const openPanel of changedState.openPanels ) {
                                const openPanelKey = openPanel.panelProps.panelKey,
                                      matches      = action.panelKey.match( `^${openPanelKey}_(.*)$` ),
                                      subPanelKey  = matches?.length === 2 ? matches[ 1 ] : undefined;

                                if ( subPanelKey ) {
                                    panelIndex = getPanelIndex( openPanelKey, changedState.openPanels );

                                    if ( panelIndex !== undefined ) {
                                        if ( !panelProps.panelKey ) {
                                            panelProps.panelKey = subPanelKey;
                                        }

                                        changedState.openPanels = ( [] as PanelConfig[] ).concat( changedState.openPanels );
                                        changedState.openPanels[ panelIndex ] = Object.assign( {}, changedState.openPanels[ panelIndex ] );
                                        changedState.openPanels[ panelIndex ].panelProps = Object.assign( {}, changedState.openPanels[ panelIndex ].panelProps );

                                        const subPanelPath = subPanelKey.split( '_' );
                                        let parentProps = changedState.openPanels[ panelIndex ].panelProps;

                                        for ( let i = 0; i < subPanelPath.length; i++ ) {
                                            if ( parentProps.subPanelProps === undefined ) {
                                                parentProps.subPanelProps = {};
                                            }
                                            else {
                                                parentProps.subPanelProps = Object.assign( {}, parentProps.subPanelProps );
                                            }

                                            // end up
                                            if ( i === subPanelPath.length - 1 ) {
                                                parentProps.subPanelProps[ subPanelPath[ i ] ] = panelProps;
                                            }

                                            // step deeper
                                            else {
                                                if ( parentProps.subPanelProps[ subPanelPath[ i ] ] === undefined ) {
                                                    parentProps.subPanelProps[ subPanelPath[ i ] ] = {};
                                                }
                                                parentProps = parentProps.subPanelProps[ subPanelPath[ i ] ];
                                            }
                                        }

                                        changed = true;
                                    }
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        popupIndex = getPopupIndex( panelKey, changedState.openPopups );

                        // popup
                        if ( popupIndex !== undefined ) {
                            if ( !panelProps.panelKey ) {
                                panelProps.panelKey = panelKey;
                            }
                            changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                            changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );

                            changedState.openPopups[ popupIndex ].panelProps = panelProps;

                            changed = true;
                        }

                        // subPanel(s)
                        else {
                            for ( const openPanel of changedState.openPopups ) {
                                const openPanelKey = openPanel.panelProps.panelKey,
                                      matches      = action.panelKey.match( `^${openPanelKey}_(.*)$` ),
                                      subPanelKey  = matches?.length === 2 ? matches[ 1 ] : undefined;

                                if ( subPanelKey ) {
                                    popupIndex = getPopupIndex( openPanelKey, changedState.openPopups );

                                    if ( popupIndex !== undefined ) {
                                        if ( !panelProps.panelKey ) {
                                            panelProps.panelKey = subPanelKey;
                                        }

                                        changedState.openPopups = ( [] as PanelConfig[] ).concat( changedState.openPopups );
                                        changedState.openPopups[ popupIndex ] = Object.assign( {}, changedState.openPopups[ popupIndex ] );
                                        changedState.openPopups[ popupIndex ].panelProps = Object.assign( {}, changedState.openPopups[ popupIndex ].panelProps );

                                        const subPanelPath = subPanelKey.split( '_' );
                                        let parentProps = changedState.openPopups[ popupIndex ].panelProps;

                                        for ( let i = 0; i < subPanelPath.length; i++ ) {
                                            if ( parentProps.subPanelProps === undefined ) {
                                                parentProps.subPanelProps = {};
                                            }
                                            else {
                                                parentProps.subPanelProps = Object.assign( {}, parentProps.subPanelProps );
                                            }

                                            // end up
                                            if ( i === subPanelPath.length - 1 ) {
                                                parentProps.subPanelProps[ subPanelPath[ i ] ] = panelProps;
                                            }

                                            // step deeper
                                            else {
                                                if ( parentProps.subPanelProps[ subPanelPath[ i ] ] === undefined ) {
                                                    parentProps.subPanelProps[ subPanelPath[ i ] ] = {};
                                                }
                                                parentProps = parentProps.subPanelProps[ subPanelPath[ i ] ];
                                            }
                                        }

                                        changed = true;
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
                break;

            case PANELMANAGER_SET_SCROLLPOSITION:
                ( { scrollPosition } = action );

                if (
                    scrollPosition !== undefined
                    && changedState.scrollPosition !== scrollPosition
                ) {
                    changedState.scrollPosition = scrollPosition;

                    changed = true;
                }

                break;
        }

        if ( changed ) {
            retVal = changedState;
        }
    }

    return retVal;
}
